import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Empty, notification} from "antd";
import _ from "lodash";
import {Button, Icon, Loading, Modal} from "~/components";
import ActionBar from "~/layout/ActionBar";
import {apiError, handleRequest} from "~/utils";
import {cronjobApi} from "~/api";
import {CronJobFormAdd, CronJobTable} from "../components";
import {
    cronjobActions,
    cronjobErrorSelector,
    cronjobFilterSelector,
    cronjobItemsSelector,
    cronjobLoadingSelector,
    cronjobPaginationSelector,
} from "../cronjobSlice";

function CronJob()
{
    const dispatch = useDispatch();
    const items = useSelector(cronjobItemsSelector);
    const loading = useSelector(cronjobLoadingSelector);
    const error = useSelector(cronjobErrorSelector);
    const pagination = useSelector(cronjobPaginationSelector);
    const filter = useSelector(cronjobFilterSelector);

    const [itemEdit, setItemEdit] = useState({});
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openModal, setOpenModal] = useState({add: false, delete: false});

    const handleModalOpen = (modal) => {
        setOpenModal(prev => ({...prev, [modal]: true}));
    };

    const handleModalClose = (modal) => {
        setOpenModal(prev => ({...prev, [modal]: false}));
    };

    const eventsHandler = {
        load: () => {
            dispatch(cronjobActions.fetchData({...filter}));
        },
        changePagination: (page) => {
            dispatch(cronjobActions.setFilter({...filter, page}));
        },
        add: async (data) => {
            const [error, response] = await handleRequest(cronjobApi.add(data));
            const message = apiError('Them cronjob that bai', error, response);

            if(!message) {
                notification.success({message: 'Thanh cong', description: 'Thêm cronjob thành công'});
                dispatch(cronjobActions.add(response.data));
                handleModalClose('add');
            }
        },
        delete: async () => {
            if(!itemEdit?.id) {
                notification.error({message: 'Loi', description: 'Không tìm thấy cronjob để xóa'});
                return false;
            }

            setLoadingDelete(true);
            const [error, response] = await handleRequest(cronjobApi.delete(itemEdit.id));
            const message = apiError('Xóa cronjob thất bại', error, response);

            if(!message) {
                notification.success({message: 'Thành công', description: 'Xóa cronjob thành công'});
                dispatch(cronjobActions.delete(itemEdit.id));
                handleModalClose('delete');
            }

            setLoadingDelete(false);
        },
    };

    useEffect(() => {
        dispatch(cronjobActions.fetchData({...filter}));
    }, [dispatch, filter]);

    if(error) {
        notification.error({message: 'Có lỗi xảy ra', description: error});
    }

    return (
        <>
            <ActionBar title="Cronjob">
                <Button outline leftIcon={Icon.plusCircle} onClick={() => handleModalOpen('add')}>Thêm mới</Button>
                <Button outline small onClick={eventsHandler.load} style={{fontSize: '20px'}}>{Icon.reload}</Button>
            </ActionBar>
            <div className="container">
                <div className="content">
                    {loading && <Loading />}
                    {!_.isEmpty(items) && <CronJobTable
                        items={items}
                        pagination={pagination}
                        onPaginationChange={eventsHandler.changePagination}
                        openModal={handleModalOpen}
                        setItemEdit={setItemEdit}
                    />}
                    {_.isEmpty(items) && !loading && <Empty />}
                </div>
            </div>
            {openModal.add && <Modal title="Thêm cronjob" visible={openModal.add} onCancel={() => handleModalClose('add')}>
                <CronJobFormAdd onHandleSubmit={eventsHandler.add} />
            </Modal>}
            {itemEdit?.id && openModal.delete && <Modal title="Xoa cronjob" visible={openModal.delete} onCancel={() => handleModalClose('delete')}>
                <p>Bạn muốn xóa cronjob <b>{itemEdit.crontime}</b>?</p>
                <p>{itemEdit.url}</p>
                <br />
                <div className="d-flex justify-content-end gap">
                    <Button white leftIcon={Icon.close} onClick={() => handleModalClose('delete')}>Dong</Button>
                    <Button loading={loadingDelete} primary leftIcon={Icon.delete} onClick={eventsHandler.delete}>Xoa</Button>
                </div>
            </Modal>}
        </>
    );
}

export default CronJob;
